<!-- PROGRESS BAR -->
<fuse-progress-bar></fuse-progress-bar>
<!-- / PROGRESS BAR -->

<!-- AD GROUP BASE LAYOUT -->
<ng-container>
  <base-layout></base-layout>
</ng-container>
<!-- / AD GROUP BASE LAYOUT -->
